var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.type !== null && _vm.dialog)?_c('dialog-with-polling',{key:_vm.rerenderCount,attrs:{"title":_vm.title || '',"type":_vm.type,"open":_vm.dialog,"cancel":_vm.hide,"templates":_vm.exportTemplates,"formats":_vm.availableFormats,"trigger-export":_vm.triggerExport}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }